import './DownloadsPage.css'
import {useState, useEffect} from 'react'
import axios from 'axios';
import SoftwarePlaceholder from "../../Assets/Images/SoftwareIconPlaceholder.svg"; 


function runDownloadLink(link) {
  try {
    console.log(link); 
    const element = document.createElement('a');
    element.href = link.url; 
    document.body.appendChild(element); 
    element.click(); 
    element.parentNode.removeChild(element);
  }
  catch {
    console.log("Error")
  }
}


/// Download Function
function DownloadSoftware({info, osName, version, isArchive}){
  console.log("Download software at link: " + info.name, info.id, osName, version); 
  const token = localStorage.getItem('token'); 
  axios.get('/api/downloads/', {
    headers: {'Authorization': `Token ${token}`}, 
    params: {
      'softwareKey': `${info.id}`, 
      'isArchive': `${isArchive}`, 
      'operatingSystem': `${osName}`,
      'version' : version
    }
  })
  .then((response) => {
    if (response.status === 200)
      console.log("Could download software..")
      runDownloadLink(response.data);
  })
  .catch((error) => {
    console.log("Could not download software...", error)
  })
}


/// Setup Links for Supplied OSes in the Info
function getDownloadLinks({info, version, isArchive}) {  
  let links = []

  for (let i in info.operatingSystems) {
    const osName = info.operatingSystems[i]; 

    const downloadSoftware = () => {
      DownloadSoftware({info, osName, version, isArchive})
    }

    let os = (
      <button key={info.id + i + version} onClick={downloadSoftware} className='LinkButton'>
        {osName}
      </button>
    )
    let div = (
      <label key={info.id + i + version + 2} style={{fontSize:12, color:'#969696', padding:5}}>/</label>
    )
    links.push(os)
    links.push(div)
  }
  /// Remove Last (which will be a divider)
  links.pop(); 
  return links;
}



/// Software Card 
function SoftwareCard({info}) {
  const isArchive = false; 
  const version = info.version; 
  const downloadLinks = getDownloadLinks({info, version, isArchive})
  if (version === '0.0.0')
    return (<></>)

  return (
    <div className='DownloadsPage-Card'>
      <div className='DownloadsPage-Item'><img src={SoftwarePlaceholder} alt={SoftwarePlaceholder}/></div>
      <div style={{
              display:'flex',
              flexDirection:'column',
              justifyContent:'flex-start',
              alignItems:'flex-start',
              padding:20,
          }}>
          <label style={{fontSize:11, fontWeight:'800'}}>{info.name}</label>
          <label style={{fontSize:11, textAlign:'left'}}>{info.description}</label>
      </div>
      <div className='DownloadsPage-Item'>
        <div style={{
          display:'grid',
          gridTemplateColumns:'auto auto',
          gridTemplateRows:'auto 5px, auto, 5px',
          margin:10
        }}>  
          <label style={{fontSize:10, fontWeight:'bold', color:'#969696'}}>Version</label>
          <label style={{fontSize:10, fontWeight:'bold', color:'#969696'}}>Download</label>
          <hr style={{ borderWidth: '1px', width:'100%',  border:'1px solid #3c3c3c'}}/>
          <hr style={{ borderWidth: '1px', width:'100%',  border:'1px solid #3c3c3c'}}/>
          <label style={{fontSize:12, margin:2, color:'#969696'}}>{info.version}</label>
        <div> 
          {downloadLinks}
        </div>
          <hr style={{ borderWidth: '1px', width:'100%', border:'1px solid #3c3c3c'}}/>
          <hr style={{ borderWidth: '1px', width:'100%',  border:'1px solid #3c3c3c'}}/>
        </div>
      </div>
    </div>
  )
}

/*
* Archived Software 
* Returns the details for all the available versions of the specified software
*/
function ArchiveSoftware({info}) {
  if (info.archiveVersions == null || info.archiveVersions.length === 0)
    return (<></>)
  return (
    <div style={{
      // padding:10, 
      margin:5,
    }}>
      <details style={{color:"#969696"}}>
        <summary>{info.name}</summary>
        <div style={{
          margin:0,
          display:'grid',
          gridTemplateColumns:'auto', 
          gridTemplateRows:'auto auto', 
        }}>
          <table style={{width:'100%'}}> 
           <thead> 
            <tr style={{
              fontSize:12,
              fontWeight:800,
              textAlign:'center'
            }}> 
              <th style={{width:150, borderWidth:'1px', borderColor:"#3c3c3c", borderBottomStyle:'solid', color:"#3c3c3c"}}>Version</th>
              <th style={{width:150, borderWidth:'1px', borderColor:"#3c3c3c", borderBottomStyle:'solid', color:"#3c3c3c"}}>Download</th>
            </tr>
          </thead>
          <tbody> 
            {
              info.archiveVersions.map((obj, index)=> {
                const version = obj
                const isArchive = true; 
                const downloadLinks = getDownloadLinks({info, version, isArchive})
                return (
                    <tr key={info.id + index + 1} style={{
                      fontSize:12,
                      textAlign:'center'
                    }}> 
                      <td key={info.id + index + 2} style={{borderWidth:'1px', borderColor:"#3c3c3c", borderBottomStyle:'solid', color:"#969696"}}>{obj}</td>
                      <td key={info.id + index + 3} style={{borderWidth:'1px', borderColor:"#3c3c3c", borderBottomStyle:'solid', color:"#3c3c3c"}}>{downloadLinks}</td>
                    </tr>
                )
              })
            }
          </tbody>
        </table>
      </div> 
      </details>
    </div>
  )
}




/**
 * The Full Archives page for all the different software 
 * Returns the jsx for the archives
 */
function ArchivesPage({canvasInfo, venueInfo, liveInfo, pluginsInfo, 
                        ipadInfo, auralizerInfo, auralizer2Info, spatializerInfo, 
                        autocheckInfo, speakerDSPInfo, filterProduct}) {
  return (
    <div style={{
      display:'flex',
      flexDirection:'row',
      textAlign:'left'
    }}> 
    <details style={{color:"#969696"}}> 
      <summary> Archives </summary>
      <div style={{
        display:'grid',
        gridTemplateColumns:'auto', 
        gridTemplateRows:'auto, auto, auto, auto, auto, auto, auto', 
        width:'91vw',
        margin:'10px',
        textAlign:'left'
      }}>
        <p style={{fontSize:12}}>For additional archives please contact us, at audio.dev@thesphere.com</p>
        <hr style={{width:'100%', border:'0.5px solid #3c3c3c'}}/> 
        {filterProduct(pluginsInfo.id)  && <ArchiveSoftware info={pluginsInfo}/>}
        {filterProduct(auralizerInfo.id)  && <ArchiveSoftware info={auralizerInfo}/>}
        {filterProduct(auralizer2Info.id) && <ArchiveSoftware info={auralizer2Info}/>} 
        {filterProduct(venueInfo.id) && <ArchiveSoftware info={venueInfo}/>}
        {filterProduct(liveInfo.id) && <ArchiveSoftware info={liveInfo}/>}
        {filterProduct(autocheckInfo.id)  && <ArchiveSoftware info={autocheckInfo}/>}
        {filterProduct(speakerDSPInfo.id)  && <ArchiveSoftware info={speakerDSPInfo}/>}
        {filterProduct(spatializerInfo.id) && <ArchiveSoftware info={spatializerInfo}/>}
      </div>
      </details> 
    </div>
  ); 
}



function getSoftwareInfo(setInfo, key) {
  const token = localStorage.getItem('token'); 
  axios.get('/api/softwareInfo/', {
    headers: {'Authorization': `Token ${token}`}, 
    params: {'softwareKey': `${key}`}
  })
  .then(response => {
      if (response.status === 200) {
        setInfo(response.data); 
      }
  })
  .catch(error => {
      setInfo({}); 
  });
}




/**
  Downloads Page 
  This is the full page for the downloads
 */
function DownloadsPage() {
  const defaultObj = {
    'name' : '', 
    'description' : '',
    'id' : '', 
    'version' : '0.0.0', 
    'archiveVersions' : [], 
    'operatingSystems' : [], 
  }

  const [canvasInfo, setCanvasInfo] = useState(defaultObj); 
  const [venueInfo, setVenueInfo] = useState(defaultObj); 
  const [liveInfo, setLiveInfo] = useState(defaultObj); 
  const [pluginsInfo, setPluginInfo] = useState(defaultObj); 
  const [autoCheckInfo, setAutocheckInfo] = useState(defaultObj); 
  const [speakerDSPInfo, setSpeakerDSPInfo] = useState(defaultObj); 
  const [ipadInfo, setIPadInfo] = useState(defaultObj); 
  const [auralizerInfo, setAuralizerInfo] = useState(defaultObj); 
  const [auralizer2Info, setAuralizer2Info] = useState(defaultObj); 
  const [spatializerInfo, setSpatializerInfo] = useState(defaultObj);
  const [entitledProductNames, setEntitledProductNames] = useState([]);

  const filterProduct = (softwareId) =>
    !!softwareId && entitledProductNames.some(name => name.toLowerCase() === softwareId.toLowerCase());

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    axios.get('/api/myProducts/', {
      headers: {'Authorization': `Token ${token}`},
    })
    .then(response => {
      if (response.status === 200)
        setEntitledProductNames(response.data.products);
    })
    .catch(() => setEntitledProductNames([]));
  }, []); 

  useEffect(()=>{
    getSoftwareInfo(setCanvasInfo, 'canvas'); 
    getSoftwareInfo(setVenueInfo, 'Canvas-Venue'); 
    getSoftwareInfo(setLiveInfo, 'Canvas-Live'); 
    getSoftwareInfo(setPluginInfo, 'SpatializationPlugins');
    getSoftwareInfo(setAutocheckInfo, 'Autocheck');
    getSoftwareInfo(setSpeakerDSPInfo, 'SpeakerDSP');
    getSoftwareInfo(setIPadInfo, 'touch');
    getSoftwareInfo(setAuralizerInfo, 'SphereAuralizer');
    getSoftwareInfo(setAuralizer2Info, 'Auralizer-v2');
    getSoftwareInfo(setSpatializerInfo, 'spatializer'); 
  }, [])

  return (
    <div className='DownloadsPage'> 
      <div> 
        <hr className='DownloadsPage-lr' style={{ border:'0.5px solid #3c3c3c'}}/> 
      </div>
      <div> 
        <details open> 
          <summary className='DownloadsPage-accordsummary'>Latest Versions</summary>
              {filterProduct(pluginsInfo.id)     && <SoftwareCard info={pluginsInfo}/>}
              {filterProduct(auralizerInfo.id)   && <SoftwareCard info={auralizerInfo}/>}
              {filterProduct(auralizer2Info.id)  && <SoftwareCard info={auralizer2Info}/>}
              {filterProduct(autoCheckInfo.id)   && <SoftwareCard info={autoCheckInfo}/>}
              {filterProduct(venueInfo.id)       && <SoftwareCard info={venueInfo}/>}
              {filterProduct(liveInfo.id)        && <SoftwareCard info={liveInfo}/>}
              {filterProduct(speakerDSPInfo.id)  && <SoftwareCard info={speakerDSPInfo}/>}
        </details>
      </div>
      <div> 
        <hr className='DownloadsPage-lr' style={{ border:'0.5px solid #3c3c3c'}}/> 
      </div>
      <div>
        <ArchivesPage canvasInfo={canvasInfo}
                      venueInfo={venueInfo}
                      liveInfo={liveInfo}
                      pluginsInfo={pluginsInfo}
                      ipadInfo={ipadInfo}
                      auralizerInfo={auralizerInfo}
                      auralizer2Info={auralizer2Info}
                      spatializerInfo={spatializerInfo}
                      autocheckInfo={autoCheckInfo}
                      speakerDSPInfo={speakerDSPInfo}
                      filterProduct={filterProduct}
        />
      </div>
    </div>
  )

}



export default DownloadsPage;
